var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Savable } from 'app/services/storage/savable';
import { LocalStorageService } from 'app/services/storage/local-storage.service';
var SidebarSettingsService = /** @class */ (function (_super) {
    __extends(SidebarSettingsService, _super);
    function SidebarSettingsService(_localStorageService) {
        var _this = _super.call(this, _localStorageService) || this;
        _this._localStorageService = _localStorageService;
        _this.restore();
        return _this;
    }
    SidebarSettingsService.prototype.restore = function () {
        var restored = _super.prototype.restore.call(this);
        this.visible = restored.visible || true;
        return this;
    };
    __decorate([
        Savable.property,
        __metadata("design:type", Boolean)
    ], SidebarSettingsService.prototype, "visible", void 0);
    SidebarSettingsService = __decorate([
        Savable.key('sidebarSettings'),
        __metadata("design:paramtypes", [LocalStorageService])
    ], SidebarSettingsService);
    return SidebarSettingsService;
}(Savable));
export { SidebarSettingsService };
